import React from "react"
import bannersStore from "../stores/bannersStore"
import botStore from "../stores/botStore"
import BannerCardList from "../components/Banners/BannerCardList"
import { PlusOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router-dom"
import DynamicBannerLink from "../components/Banners/DynamicBannerLink"

const Banners = () => {
    const navigate = useNavigate()
    const setSelectedBanner = bannersStore((state) => state.setSelectedBanner)
    const bot = botStore((state) => state.bot)

    return (
        <>
            <header
                style={{
                    textAlign: "center",
                    background: "#1e1e1e",
                    borderBottom: "1px solid #333",
                    padding: "20px",
                    color: "#e0e0e0",
                }}
            >
                <h1
                    style={{
                        margin: 0,
                        color: "#ffffff",
                        fontSize: "2rem",
                        fontWeight: "600",
                    }}
                >
                    مشاهده بنر های
                    <br />
                    {bot?.templateName}
                </h1>
                <p
                    style={{
                        margin: "10px 0 0 0",
                        color: "#b0b0b0",
                        fontSize: "1.1rem",
                    }}
                >
                    میتوانید بنر ها رو در اینجا مدیریت کنید
                </p>
            </header>
            <div
                className="p-5"
                style={{ backgroundColor: "#121212", height: "100%", color: "#e0e0e0" }}
            >
                <div className="flex justify-center ">
                    <button
                        onClick={() => {
                            setSelectedBanner(null)
                            navigate("/banner-editor")
                        }}
                        className="bg-blue-500 text-white rounded-md py-1 px-4"
                    >
                        <span className="pr-2">ساخت بنر</span>
                        <PlusOutlined />
                    </button>
                </div>
                <DynamicBannerLink />
                <BannerCardList />
            </div>
        </>
    )
}

export default Banners
